import { BookHeartOutlineIcon } from './BookHeartOutlineIcon';

/**
 * author: Austin Andrews
 * id 72206137-0CFE-4A3C-BA21-16EB71D39821
 * name book-heart-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-heart-outline.svg
 * tags
 */
export const BookFavoriteOutlineIcon = BookHeartOutlineIcon;
export default BookFavoriteOutlineIcon